import { z } from 'zod/v4';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
export var AgentRunOutcome;
(function (AgentRunOutcome) {
    AgentRunOutcome["NoActionNeeded"] = "NO_ACTION_NEEDED";
    AgentRunOutcome["EscalatedToHuman"] = "ESCALATED_TO_HUMAN";
    AgentRunOutcome["UnableToProceed"] = "UNABLE_TO_PROCEED";
})(AgentRunOutcome || (AgentRunOutcome = {}));
const inputSchema = z.object({
    outcome: z
        .enum([AgentRunOutcome.NoActionNeeded, AgentRunOutcome.UnableToProceed])
        .describe([
        'NO_ACTION_NEEDED: case is in good order, nothing for a human to do either. Default outcome when the run finds nothing actionable.',
        'UNABLE_TO_PROCEED: hit a tool limit, missing data the tools cannot retrieve, or a corrupted case shape. Used to flag a system/tooling gap, not a judgement call.',
    ].join(' ')),
    summary: z
        .string()
        .min(1)
        .max(2000)
        .describe('Short human-readable explanation of what you found and why you ended the run this way.'),
});
const outputSchema = z.object({
    acknowledged: z.literal(true),
});
export const reportOutcomeTool = {
    name: ToolName.ReportOutcome,
    category: ToolCategory.Meta,
    weight: ToolWeight.Terminal,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'Report your final outcome and end the run. Use NO_ACTION_NEEDED when no change is necessary. Use UNABLE_TO_PROCEED for a system or tooling gap. Use escalate_to_human instead when a concrete action or decision needs human attention. Calling this terminates the run.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=report-outcome.js.map